import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import QUERY_KEYS from '../utils/QueryKeys';

// The "Growing Up" pair: this student's representative portrait from the same season a
// year ago ("then") and the current season ("now"), as watermarked-proof cutouts. The
// server returns { previous, current }, each { pose_id, season, watermark_url } — or both
// null when there is no prior-year portrait (then-and-now or nothing; never "now" alone).
export default function useGrowthThumbnails(studentId, season) {
  return useQuery(
    [QUERY_KEYS.GROWTH_THUMBNAILS, studentId, season],
    () => axios
      // axios baseURL is already /api/v1 (see the app's axios config).
      .get(`/students/${studentId}/growth_thumbnails`, { params: { season } })
      .then((res) => res.data),
    { enabled: !!(studentId && season), staleTime: 5 * 60 * 1000, placeholderData: null },
  );
}
